import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    badge: 'From Shine Plus',
    button: 'Compare our offers',
    description:
      'The products and services catalogue is available from the Plus subscription.\nIt allows you to save your recurring items so that you can create quotes and invoices in just one click.',
    retrieveTitle: 'Find your saved articles',
    saveTitle: 'Save your recurring items',
  },
  fr: {
    badge: 'À partir de Shine Plus',
    button: 'Comparer nos offres',
    description:
      "Le catalogue de produits et services est disponible à partir de l'abonnement Plus.\nIl permet d'enregistrer vos articles récurrents pour créer vos devis et factures en un clic.",
    retrieveTitle: 'Retrouvez vos articles enregistrés',
    saveTitle: 'Enregistrez vos articles récurrents',
  },
} as const);

export default locales;
